import React, { useMemo } from 'react';
import './style.css';

const DEFAULT_COLOR = '#111827';
const DEFAULT_STROKE_WIDTH = 3;
const MIN_SIZE = 1;

const normalizeHexColor = (value) => {
  const raw = typeof value === 'string' ? value.trim() : '';
  return /^#([0-9a-fA-F]{6})$/.test(raw) ? raw : DEFAULT_COLOR;
};

const normalizeStrokeWidth = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return DEFAULT_STROKE_WIDTH;
  return Math.min(24, Math.max(1, Math.round(numeric)));
};

const StraightLineNode = ({ data, selected }) => {
  const line = data?.line || {};
  const stroke = normalizeHexColor(line.color);
  const strokeWidth = normalizeStrokeWidth(line.strokeWidth);
  const padding = Math.max(8, strokeWidth * 2);
  const width = Math.max(MIN_SIZE, Number(line.width) || MIN_SIZE);
  const height = Math.max(MIN_SIZE, Number(line.height) || MIN_SIZE);
  const start = line.start || { x: padding, y: padding };
  const end = line.end || { x: width - padding, y: height - padding };

  const viewBox = useMemo(
    () => `0 0 ${Math.max(MIN_SIZE, width)} ${Math.max(MIN_SIZE, height)}`,
    [height, width],
  );

  return (
    <div
      className={`straight-line-node${selected ? ' is-selected' : ''}`}
      style={{ width: `${width}px`, height: `${height}px` }}
      data-inline-width={width}
      data-inline-height={height}
    >
      <svg
        className="straight-line-node__svg"
        width={width}
        height={height}
        viewBox={viewBox}
        role="presentation"
      >
        <line
          className="straight-line-node__line"
          x1={start.x}
          y1={start.y}
          x2={end.x}
          y2={end.y}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      {data?.showResizeHandle ? (
        <>
          <button
            type="button"
            className="straight-line-node__resize straight-line-node__resize--start"
            style={{ left: `${start.x}px`, top: `${start.y}px` }}
            aria-label="Mover inicio de linea"
            onPointerDown={(event) => data.onResizeEndpointPointerDown?.(event, 'start')}
          />
          <button
            type="button"
            className="straight-line-node__resize straight-line-node__resize--end"
            style={{ left: `${end.x}px`, top: `${end.y}px` }}
            aria-label="Mover fin de linea"
            onPointerDown={(event) => data.onResizeEndpointPointerDown?.(event, 'end')}
          />
        </>
      ) : null}
    </div>
  );
};

export default StraightLineNode;
